'use client';

import React, { useEffect } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { App, message as staticMessage, notification as staticNotification, Modal as staticModal } from 'antd';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 30000,
    },
  },
});

/** App 内层：把 antd App 实例的 message/notification/modal 绑定回静态方法，
 *  使全站仍用静态 message.error() 等调用的页面也能正常显示提示（antd v5 中
 *  App 组件存在时静态方法默认不渲染）。 */
function AntdStaticBinder() {
  const { message, notification, modal } = App.useApp();
  useEffect(() => {
    staticMessage.success = message.success;
    staticMessage.error = message.error;
    staticMessage.warning = message.warning;
    staticMessage.info = message.info;
    staticMessage.loading = message.loading;
    staticMessage.open = message.open;
    staticNotification.success = notification.success;
    staticNotification.error = notification.error;
    staticNotification.warning = notification.warning;
    staticNotification.info = notification.info;
    staticNotification.open = notification.open;
    staticModal.confirm = modal.confirm;
    staticModal.info = modal.info;
    staticModal.success = modal.success;
    staticModal.error = modal.error;
    staticModal.warning = modal.warning;
  }, [message, notification, modal]);
  return null;
}

export default function Providers({ children }: { children: React.ReactNode }) {
  return (
    <QueryClientProvider client={queryClient}>
      <App>
        <AntdStaticBinder />
        {children}
      </App>
    </QueryClientProvider>
  );
}
